<template>
 <el-scrollbar style="height:100%">
    <div class="menuTreeDiv" :style="'height:' + height + 'px;'" v-if="this.menuData.length > 0">
            <el-menu class="menu-Bar" :default-active="activeIndex">
                <template v-for="(value, i) in this.menuData">
                    <el-submenu :index="value.menuId" v-if="value.children.length > 0" :key="i">
                        <template slot="title">
                            <img :key="i" :src="'.' + (value.menuIconUrl == '' ? beforeImgUrl : value.menuIconUrl) + '/' + menuImgUrl + value.menuIcon" v-if="value.menuIcon" class="imgClass" />
                            <span slot="title" :title="value.menuName">{{ value.menuName }}</span>
                        </template>
                        <template v-for="(valueTwo, j) in value.children">
                            <el-submenu :index="valueTwo.menuId" v-if="valueTwo.children.length > 0" :key="j">
                                <template slot="title">
                                    <img :key="j" :src="'.' + (value.menuIconUrl == '' ? beforeImgUrl : value.menuIconUrl) + '/' + menuImgUrl + value.menuIcon" v-if="value.menuIcon" class="imgClass" />
                                    <span slot="title" :title="valueTwo.menuName">{{ valueTwo.menuName }}</span>
                                </template>
                                <template v-for="(valueThree, k) in valueTwo.children">
                                    <el-menu-item :index="valueThree.menuId" :key="k" @click="linkModuleLeftMenuTree(valueThree)">
                                        <img :src="'.' + (value.menuIconUrl == '' ? beforeImgUrl : value.menuIconUrl) + '/' + menuImgUrl + value.menuIcon" v-if="value.menuIcon" class="imgClass" />
                                        <span slot="title" :title="valueThree.menuName">{{ valueThree.menuName }}</span>
                                    </el-menu-item>
                                </template>
                            </el-submenu>
                            <el-menu-item :index="valueTwo.menuId" v-else :key="j" @click="linkModuleLeftMenuTree(valueTwo)">
                                <img :key="i" :src="'.' + (value.menuIconUrl == '' ? beforeImgUrl : value.menuIconUrl) + '/' + menuImgUrl + value.menuIcon" v-if="value.menuIcon" class="imgClass" />
                                <span slot="title" :title="valueTwo.menuName">{{ valueTwo.menuName }}</span>
                            </el-menu-item>
                        </template>
                    </el-submenu>
                    <el-menu-item :index="value.menuId" v-else :key="i" @click="linkModuleLeftMenuTree(value)">
                        <img :key="i" :src="'.' + (value.menuIconUrl == '' ? beforeImgUrl : value.menuIconUrl) + '/' + menuImgUrl + value.menuIcon" v-if="value.menuIcon" class="imgClass" />
                        <span slot="title" :title="value.menuName">{{ value.menuName }}</span>
                    </el-menu-item>
                </template>
            </el-menu>
         
    </div>
   </el-scrollbar>
</template>
<script>
export default {
    props: {
        leftMenuData: Array,
        linkModule: {
            type: Function,
            default: null
        },
        curentTopMenuId: String,
        indexId: String
    },
    data() {
        return {
            activeIndex: '',
            menuData: [],
            height: '',
            menuImgUrl: this.$store.state.skin + '/img/menu/',
            beforeImgUrl: '/skin'
        };
    },
    methods: {
        linkModuleLeftMenuTree: function(obj) {
            if (this.linkModule) {
                this.linkModule(obj, this.curentTopMenuId);
            }
        },
        updateIndex() {
            this.activeIndex = this.$store.state.leftMenuIndex;
            sessionStorage.setItem('leftMenuIndexId', this.activeIndex);
        }
    },
    // beforeDestroy() {
    //     this.linkModule = null;
    // },
    mounted() {
        let obj = this;
        window.addEventListener('resize', function() {
            obj.height = window.innerHeight - 60;
        });
        obj.height = window.innerHeight - 60;
    },
    watch: {
        leftMenuData(newData, oldData) {
            this.menuData = newData;
            this.$nextTick(function() {
                this.$store.state.leftMenuIndex = this.indexId;
            });
        },
        '$store.state.leftMenuIndex': 'updateIndex'
    }
};
</script>
<style scoped>
.menu-Bar:not(.el-menu--collapse) {
    /* width: 200px; */
    min-height: 100%;
}
.imgClass {
    margin-right: 7px;
}
.menuTreeDiv li {
    overflow: hidden;
    text-overflow: ellipsis;
}
>>> .el-scrollbar__wrap {
    overflow:auto;
}

>>> .el-scrollbar__bar {
    right: 0px;
}
</style>
